const ko = require("knockout");
const dayjs = require("dayjs");

function ChatEventViewModel(pollEventData, userParticipantId, useServerTimestamp = false) {
    let self = this;
    let currentDate = useServerTimestamp && pollEventData.serverUnixTimestamp ? dayjs(new Date(pollEventData.serverUnixTimestamp)) : dayjs();

    self.chatEventDate = getDateFormat();
    self.chatEventTime = currentDate.format("h:mm a");
    self.type = pollEventData.type;
    self.participantId = pollEventData.participantId;
    self.participantType = pollEventData.participantType;
    self.sequenceNumber = pollEventData.sequenceNumber;
    self.contentType = pollEventData.contentType;
    self.displayName = pollEventData.participantId === userParticipantId ? "You" : pollEventData.displayName;
    self.value = pollEventData.value;

    self.isSystemMessage = ko.computed(function () {
        return self.participantType === "System";
    });

    function getDateFormat() {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var today = '';
        today = months[currentDate.month()] + " " + currentDate.date() + ", " + currentDate.year();
        return today;
    }
}

module.exports = ChatEventViewModel;